module.exports = __webpack_public_path__ + "static/pubx-logo-c86fc109fc95d42c8a7756619bdca5ee.png";